var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select-rubric"},[_c('eg-form-group',{attrs:{"label":_vm.$t('common.rubric'),"description":"The same rubric must be used to grade all assignments selected in the previous step.","required":""}},[_c('rubric-select-from-library',{attrs:{"value":_vm.selectedRubric},on:{"input":_vm.selectRubric}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }